import { NgModule } from '@angular/core';
import { LibTickIconComponent } from './lib-tick-icon.component';

@NgModule({
  declarations: [LibTickIconComponent],
  imports: [],
  exports: [LibTickIconComponent],
})
export class LibTickIconModule {}
